// Temel importlar (her zaman yüklenmeli)
import "./Component/i18n";
import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Route, Routes } from "react-router-dom";

// CSS importları
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Ortak bileşenler (her zaman yüklenmeli - layout için gerekli)
import Header from "./Component/header";
import Footer from "./Component/footer";
import ScrollToTop from "./Component/scrollToTop";
import ErrorBoundary from "./Component/ErrorBoundary";

// Ana sayfa - Sık kullanıldığı için eager load
import Home from "./pages/home";

// Loading component
const LoadingFallback = () => (
  <div style={{ 
    display: "flex", 
    justifyContent: "center", 
    alignItems: "center", 
    minHeight: "50vh",
    fontSize: "18px"
  }}>
    Yükleniyor...
  </div>
);

// Lazy loading - Sayfalar sadece ihtiyaç duyulduğunda yüklenir
// Bu sayede ilk yükleme süresi önemli ölçüde azalır
const Register = lazy(() => import("./pages/register"));
const UserRank = lazy(() => import("./pages/user-rank"));
const ClanRank = lazy(() => import("./pages/clan-rank"));
const BannedUser = lazy(() => import("./pages/banned-user"));
const KingdomElections = lazy(() => import("./pages/kingdom-elections"));
const UpgradeRates = lazy(() => import("./pages/upgrade-rates"));
const MiningFishing = lazy(() => import("./pages/mining-fishing"));
const FragmentGem = lazy(() => import("./pages/fragment-gem"));
const DropSearch = lazy(() => import("./pages/drop-search"));
const Achievement = lazy(() => import("./pages/achievement"));
const ShozinTutorial = lazy(() => import("./pages/shozin-tutorial"));
const EventAwards = lazy(() => import("./pages/event-awards"));
const Reseller = lazy(() => import("./pages/reseller"));
const Products = lazy(() => import("./pages/products"));
const Premiums = lazy(() => import("./pages/premiums"));
const Images = lazy(() => import("./pages/images"));
const Movie = lazy(() => import("./pages/movie"));
const Turnuvalar = lazy(() => import("./pages/turnuvalar"));
const ForgotPassword = lazy(() => import("./pages/forgot-password"));
const UserCP = lazy(() => import("./pages/user-cp"));
const Packages = lazy(() => import("./pages/packages"));
const ChangePassword = lazy(() => import("./pages/change-password"));
const ChangeLockPassword = lazy(() => import("./pages/change-lock-password"));
const ChangeVipKey = lazy(() => import("./pages/change-vip-key"));
const ChangeEmail = lazy(() => import("./pages/change-email"));
const PremiumDel = lazy(() => import("./pages/premium-del"));
const PusHistory = lazy(() => import("./pages/pus-history"));
const EsnHistory = lazy(() => import("./pages/esn-history"));
const WhellHistory = lazy(() => import("./pages/Whell-history"));
const NewsPage = lazy(() => import("./pages/news"));
const NewsDetail = lazy(() => import("./pages/newsDetails"));
const TournamentDetails = lazy(() => import("./pages/tournamentsDetails"));

// Footer sayfaları (daha az kullanılan sayfalar)
const HakkimizdaPage = lazy(() => import("./pages/FooterPages/hakkimizda"));
const KullaniciSozlesme = lazy(() => import("./pages/FooterPages/kullaniciSozlesme"));
const GizlilikPolitikası = lazy(() => import("./pages/FooterPages/gizlilikPolitikasi"));
const DavranisKurallari = lazy(() => import("./pages/FooterPages/davranisKurallari"));
const Kvkk = lazy(() => import("./pages/FooterPages/kvkk"));
const BizeUlasin = lazy(() => import("./pages/FooterPages/bizeUlasin"));
const FaqPage = lazy(() => import("./pages/FooterPages/faqPage"));
const PaymentHistory = lazy(() => import("./pages/FooterPages/payment-history"));
const TimeLine = lazy(() => import("./pages/FooterPages/timeLine"));
const SendTicket = lazy(() => import("./pages/FooterPages/sendTicket"));
const KnowledgePage = lazy(() => import("./pages/FooterPages/knowledgePage"));
const GuidePage = lazy(() => import("./pages/FooterPages/gameGuide"));

// Route yapılandırması - Daha düzenli ve bakımı kolay
const routes = [
  { path: "register", component: Register },
  { path: "user-rank", component: UserRank },
  { path: "clan-rank", component: ClanRank },
  { path: "banned-users", component: BannedUser },
  { path: "kingdom-elections", component: KingdomElections },
  { path: "upgrade-rates", component: UpgradeRates },
  { path: "mining-fishing", component: MiningFishing },
  { path: "fragment-gem", component: FragmentGem },
  { path: "drop-search", component: DropSearch },
  { path: "achievement", component: Achievement },
  { path: "shozin-tutorial", component: ShozinTutorial },
  { path: "event-awards", component: EventAwards },
  { path: "reseller", component: Reseller },
  { path: "products", component: Products },
  { path: "premiums", component: Premiums },
  { path: "images", component: Images },
  { path: "movie", component: Movie },
  { path: "turnuvalar", component: Turnuvalar },
  { path: "forgot-password", component: ForgotPassword },
  { path: "user-cp", component: UserCP },
  { path: "packages", component: Packages },
  { path: "change-password", component: ChangePassword },
  { path: "change-lock-password", component: ChangeLockPassword },
  { path: "change-vip-key", component: ChangeVipKey },
  { path: "change-email", component: ChangeEmail },
  { path: "premium-del", component: PremiumDel },
  { path: "pus-history", component: PusHistory },
  { path: "esn-history", component: EsnHistory },
  { path: "whell-history", component: WhellHistory },
  { path: "hakkimizda", component: HakkimizdaPage },
  { path: "kullanici-sozlesmesi", component: KullaniciSozlesme },
  { path: "gizlilik-politikasi", component: GizlilikPolitikası },
  { path: "davranis-kurallari", component: DavranisKurallari },
  { path: "kvkk", component: Kvkk },
  { path: "bize-ulasin", component: BizeUlasin },
  { path: "sss", component: FaqPage },
  { path: "odeme-gecmisi", component: PaymentHistory },
  { path: "time-line", component: TimeLine },
  { path: "send-ticket", component: SendTicket },
  { path: "knowledge-bank", component: KnowledgePage },
  { path: "game-guide", component: GuidePage },
  { path: "news", component: NewsPage },
  { path: "news/:id", component: NewsDetail },
  { path: "turnuvalar/:id", component: TournamentDetails },
];

// Ana uygulama bileşeni
function AppComponent() {
  return (
    <>
      <ScrollToTop />
      <Suspense fallback={<LoadingFallback />}>
        <Routes>
          <Route path="/" element={<Header />}>
            {/* Ana sayfa - index route */}
            <Route index element={<Home />} />
            
            {/* Dinamik route'lar */}
            {routes.map(({ path, component: Component }) => (
              <Route key={path} path={path} element={<Component />} />
            ))}
          </Route>
        </Routes>
      </Suspense>
      <Footer />
    </>
  );
}

// React DOM root oluşturma
const root = ReactDOM.createRoot(document.getElementById("root"));

// Uygulamayı render et
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <AppComponent />
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
);

// Web vitals raporlama (performans ölçümü)
// Daha fazla bilgi: https://bit.ly/CRA-vitals
reportWebVitals();
